// hooks/useImageCropper.ts
import { useState, useRef, type ChangeEvent, type SyntheticEvent } from "react";
import { type Crop, centerCrop, makeAspectCrop } from "react-image-crop";

export function useImageCropper(aspectRatio: number = 1) {
  const [imgSrc, setImgSrc] = useState<string>("");
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<Crop>();
  const [error, setError] = useState<string>("");
  const imgRef = useRef<HTMLImageElement | null>(null);
  const previewCanvasRef = useRef<HTMLCanvasElement | null>(null);

  const onSelectFile = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setError("Please select a valid image file.");
      return;
    }

    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setImgSrc(reader.result?.toString() || "");
      setError("");
    });
    reader.readAsDataURL(file);
  };

  const onImageLoad = (e: SyntheticEvent<HTMLImageElement>) => {
    imgRef.current = e.currentTarget;
    const { width, height } = e.currentTarget;

    const crop = centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
        },
        aspectRatio,
        width,
        height,
      ),
      width,
      height,
    );
    setCrop(crop);
    setCompletedCrop(crop);
  };

  const reset = () => {
    setImgSrc("");
    setCrop(undefined);
    setCompletedCrop(undefined);
    setError("");
  };

  return {
    imgSrc,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    error,
    imgRef,
    previewCanvasRef,
    onSelectFile,
    onImageLoad,
    reset,
  };
}
